import React from 'react';
import { LabelIcon } from '@screens/players/stat.icon.styles';
import { useGame } from '@domain/game.selection/game.selection.hook';

interface StatIconProps {
  icon?: string;
  alt?: string;
  small?: boolean;
}

export const StatIcon = React.forwardRef<HTMLImageElement, StatIconProps>(({ icon, small, ...rest }: StatIconProps, ref) => {
  const game = useGame();
  const iconSrc = icon ? game.statIcons[icon] : null;
  if (!iconSrc) return null;
  return <LabelIcon $small={small} src={iconSrc} ref={ref} {...rest} />;
});
